import { Box, Chip, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Link } from "react-router-dom";
import { V2_COLORS } from "../constants/colors";
import { usePODetails } from "../api/invoiceQueries";

interface PoDetailsCardProps {
  poCode: string;
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <Box display="flex" alignItems="center" gap={3} py={1}>
      <Typography variant="subtitle1" sx={{ width: 120, flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant="body1">
        {value ?? "—"}
      </Typography>
    </Box>
  );
}

export default function PoDetailsCard({ poCode }: PoDetailsCardProps) {
  const { data, isLoading } = usePODetails(poCode);

  const po = data?.po_list?.[0];

  return (
    <Box>
      <Typography variant="h4" mb={1.5}>
        PO details
      </Typography>
      <Box sx={{ bgcolor: "background.paper", borderRadius: "8px", py: 2, pl: 1.5, pr: 3 }}>
        {isLoading ? (
          <Box display="flex" justifyContent="center" py={3}>
            <CircularProgress size={24} />
          </Box>
        ) : (
          <>
            <Row
              label="PO no."
              value={
                <Link
                  to={`/dashboard/invoice-management/${encodeURIComponent(poCode)}`}
                  style={{ color: V2_COLORS.primary, textDecoration: "underline" }}
                >
                  {poCode}
                </Link>
              }
            />
            <Row
              label="PO amount"
              value={po?.order_value !== undefined ? `₹${po.order_value.toLocaleString("en-IN")}` : "—"}
            />
            <Row
              label="Order Status"
              value={
                po?.order_status ? (
                  <Chip
                    label={po.order_status.replace(/_/g, " ").toUpperCase()}
                    size="small"
                    sx={{
                      fontWeight: 600,
                      fontSize: "12px",
                      color: po.order_status === "confirmed" ? V2_COLORS.success : V2_COLORS.textSecondary,
                      backgroundColor: po.order_status === "confirmed" ? V2_COLORS.successBg : V2_COLORS.bgMuted,
                    }}
                  />
                ) : (
                  "—"
                )
              }
            />
          </>
        )}
      </Box>
    </Box>
  );
}
